import { render, staticRenderFns } from "./dashboardMain.vue?vue&type=template&id=b49e80ac&scoped=true&"
import script from "./dashboardMain.vue?vue&type=script&lang=js&"
export * from "./dashboardMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49e80ac",
  null
  
)

export default component.exports